
<template>
  <div>
    <div class="row">
      <b-card class="w-100 mb-2" header-tag="header">
        <template #header>
          <div class="d-flex justify-content-between">
            <div class="d-flex">
              <h6 class="mb-0">Performance of the month</h6>
            </div>
            <b-dropdown id="inclusionDropdown" variant="outline-secondary" :text="summaryInclusion" size="xs">
              <b-dropdown-item @click="summaryInclusion = 'Include Package'">Include Package</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="summaryInclusion = 'Exclude Package'">Exclude Package</b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <b-overlay :show="summarySpinnerShow">
          <div class="row m-2">
            <div class="col-12 col-sm-6 col-lg" v-for="box in summaryBox" :key="box.id">
              <div class="p-3 rounded overflow-hidden position-relative text-white mb-g" :class="box.background">
                <small class="mt-2 m-0 l-h-n fw-400 text-capitalize">{{ box.label }}
                  <h3 class="fs-xxl d-block l-h-n m-0 fw-500">
                    {{ box.value }}
                  </h3>
                </small>

                <i class="fal position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1" :class="box.icon" style="font-size: 5rem"></i>
              </div>
            </div>
          </div>
        </b-overlay>
      </b-card>
    </div>
    <div class="panel">
      <div class="panel-hdr">
        <!-- <h2 class="ui-sortable-handle">{{ $t("header.yearly_sales") }}</h2> -->
        <h2 class="ui-sortable-handle">Yearly Sales</h2>
      </div>
      <div class="panel-container">
        <div class="panel-content">
          <div class="panel-tag loading-panel-tag mt-3" v-if="tableSpinnerShow">
            {{ $t("message.data.fetching", { item: $t("header.monthly_sales") }) }}
            <b-spinner class="ml-1 small-spinner" variant="secondary" type="grow"></b-spinner>
            <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
            <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
          </div>

          <dashboardMonthlySales v-if="!tableSpinnerShow && barChartData.length != 0" :barChartData="barChartData"></dashboardMonthlySales>

          <div v-if="!tableSpinnerShow" class="row mt-3">
            <div class="col-sm-12">
              <b-card no-body>
                <b-tabs v-model="tableTab" pills card>
                  <b-tab class="overflow-auto" v-for="(title, index) in tableTitles" :key="'dashboard-table' + index" :title="title">
                      <table class="table table-sm table-hover table-bordered table-striped text-center" role="grid" style="height: 1px">
                        <thead class="thead-themed">
                          <tr>
                            <th v-for="(tblHeader, i) in tableHeaders" :key="i">
                              {{ tblHeader }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(data, year, i) in tableData[index]" :key="'table-row-' + i">
                            <th>
                              <i class="fas fa-square-full color-success-50 mr-2"></i>{{ year }}
                            </th>
                            <td v-for="(item, j) in data" :key="'table-column-' + i + '-' + j">
                              {{ tableFormatDecimal.includes(index) ? formatPrice(item) : item }}
                              <!-- {{ item == 0 ? "-" : item }} -->
                            </td>
                            <td v-if="data && data.length > 0">
                              {{ sumTable(index, data) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                  </b-tab>
                </b-tabs>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div class="panel">
          <div class="panel-hdr">
            <h2 class="ui-sortable-handle">
              {{ $t("header.category_sales") }}
            </h2>
            <div class="panel-toolbar">
              <multiselect :value="selectedType" label="text" track-by="id" :options="type" :searchable="false" :show-labels="false"
                           openDirection="below" @select="filterByType">
                <template slot="option" slot-scope="{ option }">{{
                  option.text
                }}</template>
              </multiselect>
            </div>
          </div>
          <div class="panel-container">
            <div class="panel-content">
              <div class="panel-tag loading-panel-tag mt-3" v-if="isSpinnerShow">
                {{
                  $t("message.data.fetching", {
                    item: $t("header.category_sales"),
                  })
                }}
                <b-spinner class="ml-1 small-spinner" variant="secondary" type="grow"></b-spinner>
                <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
                <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
              </div>
              <div class="panel-tag" v-if="!isSpinnerShow && dataThisYear.length == 0">
                {{ $t("table.no_records") }}
              </div>
              <dashboardSalesCategory v-if="!isSpinnerShow && dataThisYear.length != 0" :pieChartData="pieChartData"></dashboardSalesCategory>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="panel">
          <div class="panel-hdr">
            <h2 class="ui-sortable-handle">{{ $t("header.type_sales") }}</h2>
          </div>
          <div class="panel-container">
            <div class="panel-content">
              <div class="panel-tag loading-panel-tag mt-3" v-if="isSpinnerShow">
                {{
                  $t("message.data.fetching", { item: $t("header.type_sales") })
                }}
                <b-spinner class="ml-1 small-spinner" variant="secondary" type="grow"></b-spinner>
                <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
                <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
              </div>
              <div class="panel-tag" v-if="!isSpinnerShow && dataThisYear.length == 0">
                {{ $t("table.no_records") }}
              </div>
              <dashboardSalesType v-if="!isSpinnerShow && dataThisYear.length != 0" :dougnutChartData="dougnutChartData"></dashboardSalesType>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel">
      <div class="panel-hdr">
        <h2 class="ui-sortable-handle">{{ $t("header.cont_items") }}</h2>
      </div>
      <div class="panel-container">
        <div class="panel-content">
          <div class="panel-tag" v-if="!isSpinnerShow && dataThisYear.length == 0">
            {{ $t("table.no_records") }}
          </div>
          <div class="panel-tag loading-panel-tag mt-3" v-if="isSpinnerShow">
            {{ $t("message.data.fetching", { item: $t("header.cont_items") }) }}
            <b-spinner class="ml-1 small-spinner" variant="secondary" type="grow"></b-spinner>
            <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
            <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
          </div>
          <div v-if="!isSpinnerShow && dataThisYear.length != 0" class="row mt-3">
            <div class="col-sm-12 overflow-auto">
              <b-table small striped hover bordered :fields="tblHdrTopItems" :items="topSalesData" :sort-compare="sortTable" responsive="sm">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(type)="data">
                  <span v-if="data.item.type == 'service'" class="badge fw-400 bg-success-900 badge-success">{{ $t("subMenu.salon_menu_service")
                  }}</span>
                  <span v-else-if="data.item.type == 'product'" class="badge fw-400 bg-danger-900 badge-danger">{{ $t("subMenu.salon_menu_product")
                  }}</span>
                  <span v-else-if="data.item.type == 'package'" class="badge fw-400 bg-primary-900 badge-primary">{{ $t("subMenu.salon_menu_package")
                  }}</span>
                  <span v-else class="badge fw-400 badge-warning">{{ $t("subMenu.salon_report_outstandings") }}</span>
                </template>
                <template #cell(category)="data">
                  {{ data.item.type == "outstandings" ? "-" : getCategoryText(data.item.type, data.item.category) }}
                </template>
                <template #cell(amount)="data">
                  {{ parseFloat(data.item.subTotal).toFixed(2) }}
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel">
      <div class="panel-hdr">
        <h2 class="ui-sortable-handle">{{ $t("header.spending_members") }}</h2>
      </div>
      <div class="panel-container">
        <div class="panel-content">
          <div class="panel-tag" v-if="!isSpinnerShow && dataThisYear.length == 0">
            {{ $t("table.no_records") }}
          </div>
          <div class="panel-tag loading-panel-tag mt-3" v-if="isSpinnerShow">
            {{ $t("message.data.fetching", { item: $t("header.spending_members"), }) }}
            <b-spinner class="ml-1 small-spinner" variant="secondary" type="grow"></b-spinner>
            <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
            <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
          </div>
          <div v-if="!isSpinnerShow && dataThisYear.length != 0" class="row mt-3">
            <div class="col-sm-12 overflow-auto">
              <b-table small striped hover bordered :fields="tblHdrTopSpendingMember" :items="topSpendingMembers" :sort-compare="sortTable"
                       responsive="sm">
                <template #cell(index)="data">{{ data.index + 1 }}</template>
                <template #cell(name)="data">
                  <i class="fal fa-user text-primary mr-2"></i>
                  <a class="text-primary fw-500 link" :title="$t('button_link.view') + $t('header.spending_items')"
                     @click="showMemberItems(data.item.item, data.item.subTotal)">{{ data.item.name }}</a>
                </template>
                <template #cell(noItem)="data">{{ data.item.count }}</template>
                <template #cell(amount)="data">{{ parseFloat(data.item.subTotal).toFixed(2) }}</template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{ show: toggleModal }" class="modal fade">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-bottom">
            <h5 class="modal-title h4">
              {{ $t("header.spending_items") }} -
              <span class="m-0 fw-300 text-muted">"{{ sTitle }}"</span>
            </h5>
            <button type="button" class="close" @click="toggleModal = false">
              <span aria-hidden="true"><i class="fal fa-times"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="dataTables_wrapper dt-bootstrap4">
              <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                  <b-table small striped hover bordered :fields="tblHdrTopSpendingMemberItem" :items="topSpendingMemberItems"
                           :sort-compare="sortTableMemberItem" responsive="sm">
                    <template #cell(index)="data">{{ data.index + 1 }}</template>
                    <template #cell(title)="data">{{ data.item.item.title }}</template>
                    <template #cell(type)="data">
                      <span v-if="data.item.type == 'service'" class="badge fw-400 bg-success-900 badge-success">{{ $t("subMenu.salon_menu_service")
                      }}</span>
                      <span v-else-if="data.item.type == 'product'" class="badge fw-400 bg-danger-900 badge-danger">{{ $t("subMenu.salon_menu_product")
                      }}</span>
                      <span v-else-if="data.item.type == 'package'" class="badge fw-400 bg-primary-900 badge-primary">{{
                        $t("subMenu.salon_menu_package") }}</span>
                      <span v-else class="badge fw-400 badge-warning">{{ $t("subMenu.salon_report_outstandings") }}</span>
                    </template>
                    <template #cell(category)="data">
                      {{ data.item.item.type == "outstandings" ? "-" : getCategoryText(data.item.item.type, data.item.item.category) }}
                    </template>
                    <template #cell(amount)="data">
                      {{ parseFloat(data.item.subTotal).toFixed(2) }}
                    </template>
                    <template #custom-foot>
                      <b-tr>
                        <b-td class="border-top-bottom-2 text-right fw-700" colspan="4">{{ $t("table.header.total", { item: "" }) }}</b-td>
                        <b-td class="border-top-bottom-2 fw-500">{{ memberItemTotal }}</b-td>
                      </b-tr>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import moment from "moment";
import DashboardMonthlySales from "./Dashboard_Monthly_Sales";
import DashboardSalesCategory from "./Dashboard_Sales_Category";
import DashboardSalesType from "./Dashboard_Sales_Type";
import { formatPrice, formatFixed, setAYearArr, } from "./../../assets/js/dashboard/utilities";
import cst, { calculateSalesReportTotal, getSubTotal, } from "./../../assets/js/dashboard/salonReport/salonReport";
import { handleSessionExpired } from "../../assets/js/dashboard/dashboard";
export default {
  name: "salesSummary",
  components: {
    DashboardMonthlySales,
    DashboardSalesCategory,
    DashboardSalesType,
  },
  props: {
    // selectedThisYear: Number,
    // selectedLastYear: Number,
    // selectedOutlet: Object,
  },
  data() {
    let time = moment()
    return {
      selectedThisYear: time.format("YYYY"),
      selectedLastYear: time.subtract(1, 'year').format("YYYY"),
      selectedOutlet: {},

      summarySpinnerShow: false,
      summaryInclusion: "Include Package",
      summaryBox: [],

      tableSpinnerShow: true,
      tableTab: 0,
      tableTitles: [],
      tableHeaders: [],
      tableData: {},
      cacheData: {},
      tableFormatDecimal: [1, 2],

      dashboardSalesSummaryBox: [],
      type: [],
      selectedType: {},
      dataThisYear: [],
      dataLastYear: [],
      barChartData: [],
      pieChartData: [],
      dougnutChartData: [],
      topSalesData: [],
      topSpendingMembers: [],
      topSpendingMemberItems: [],
      fPieChartData: [],
      isSpinnerShow: true,
      toggleModal: false,
      sTitle: "",
      memberItemTotal: 0,
      dateRange: {
        startDate: new Date(),
        endDate: new Date(),
      },
      allData: {},
      totalSales: 0,
      newMembers: 0,
      totalCustomer: 0,
      redeemSales: 0,
      serviceSales: 0,
      productSales: 0,
      packageSales: 0,
      totalAppt: 0,
      avgSales: 0,
    };
  },
  computed: {
    tblHdrTopItems() {
      return [
        {
          key: "index",
          label: "#",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "title",
          label: this.$i18n.t("table.header.title"),
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "type",
          label: this.$i18n.t("table.header.type"),
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "category",
          label: this.$i18n.t("table.header.category"),
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "quantity",
          label: this.$i18n.t("table.header.quantity"),
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "amount",
          label: this.$i18n.t("table.header.subtotal"),
          thClass: "thead-themed align-middle",
          sortable: true,
        },
      ];
    },
    tblHdrTopSpendingMember() {
      return [
        { key: "index", label: "#", thClass: "thead-themed align-middle" },
        {
          key: "name",
          label: this.$i18n.t("table.header.name"),
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "mobile",
          label: this.$i18n.t("table.header.contact"),
          thClass: "thead-themed align-middle",
        },
        {
          key: "noItem",
          label: this.$i18n.t("table.header.no_order"),
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "amount",
          label: this.$i18n.t("table.header.sales_amount"),
          thClass: "thead-themed align-middle",
          sortable: true,
        },
      ];
    },
    tblHdrTopSpendingMemberItem() {
      var arr = JSON.parse(JSON.stringify(this.tblHdrTopItems));
      var fArr = arr.filter((obj) => obj.key != "quantity");
      return fArr;
    },
  },
  watch: {
    summaryInclusion() {
      // this.getSummaryBoxData();
      this.filterData(this.selectedThisYear, this.selectedLastYear, this.selectedOutlet)
    },
    tableTab(value) {
      this.setTableChart(value)
    },
    "$i18n.locale"(val) {
      this.tableHeaders = [];
      this.tableHeaders.push("");
      this.tableHeaders.push(...this.$i18n.messages[this.$i18n.locale].calendar);
      this.tableHeaders.push(this.$i18n.t("table.header.total", { item: "" }));

      this.setItemTypes();
      var b = Object.assign({}, this.selectedType);
      this.selectedType = this.type.filter((obj) => obj.id == b.id);
    },
  },
  methods: {
    formatPrice(value) {
      return formatPrice(value)
    },
    formatFixed(value, decimal) {
      return formatFixed(value, decimal)
    },
    sumTable(index, value) {
      if (value && value.length === 0) {
        return ''
      }

      if(String(value[0]).includes('/')) {
        let sum1 = 0
        let sum2 = 0
        for (let temp of value) {
          temp = temp.split('/')
          sum1 += parseInt(temp[0])
          sum2 += parseInt(temp[1])
        }
        return `${sum1}/${sum2}`
      }

      let sum = 0
      for (let temp of value) {
        sum += temp
      }

      return this.tableFormatDecimal.includes(index) ? this.formatPrice(sum) : sum
    },

    async filterSet(thisYear, lastYear, outlet) {
      this.selectedThisYear = thisYear
      this.selectedLastYear = lastYear
      this.selectedOutlet = outlet
    },
    async filterData(thisYear, lastYear, outlet) {
      this.filterSet(thisYear, lastYear, outlet)
      this.getSummaryBoxData()
      this.getTableBoxData()
    },

    async getSummaryBoxData() {
      let $vm = this;
      $vm.summaryBox = [];
      $vm.summarySpinnerShow = true;

      let task = []
      task.push($vm.getSummaryData("allData", "all", ""))
      // task.push($vm.getSummaryData("newMembers", "first", "&first=sale"))
      // task.push($vm.getSummaryData("totalCustomer", "member/total"))
      // task.push($vm.getSummaryData("totalCustomer", "sale", "&resultType=saleid"))
      // task.push($vm.getSummaryData("totalCustomer", "visit/sale", ""))
      // task.push($vm.getSummaryData("totalSales", "sale", ""))
      // task.push($vm.getSummaryData("redeemCustomer", "redeem", "&resultType=saleid"))
      // task.push($vm.getSummaryData("redeemSales", "redeem", ""))
      // task.push($vm.getSummaryData("serviceSales", "sale/service"))
      // task.push($vm.getSummaryData("productSales", "sale/product"))
      // task.push($vm.getSummaryData("packageCustomer", "sale", "&skuType=packages&resultType=saleid"))
      task.push($vm.getSummaryData("packageSales", "sale", "&skuType=packages"))
      // task.push($vm.getSummaryData("totalAppt", "book/total", ""))

      let error = await Promise.all(task).catch(e => false)
      if (error === false) {
        this.summarySpinnerShow = false
        return
      }

      if (this.summaryInclusion === "Exclude Package") {
        this.allData['sale']['amount'] = this.allData['sale']['amount'] - this.packageSales['sales']['amount'] + this.allData['redeem']['amount'];
        // $vm.totalCustomer = $vm.totalCustomer - $vm.packageCustomer + $vm.redeemCustomer;
      }

      if (this.allData['sale']['amount'] && this.allData['visit']['sales']) {
        $vm.avgSales = this.allData['sale']['amount'] / this.allData['visit']['sales']
      } else {
        $vm.avgSales = 0;
      }

      $vm.summaryBox.push({
        id: "newMembers",
        label: "New Customers",
        background: "bg-primary-300",
        icon: "fa-chart-line",
        value: this.allData['member']['firstTimeSale'],
      });

      $vm.summaryBox.push({
        id: "totalCustomer",
        label: "Total Customers",
        background: "bg-warning-400",
        icon: "fa-chart-line",
        value: this.allData['visit']['sales'],
      });

      $vm.summaryBox.push({
        id: "totalSales",
        label: "Total Sales",
        background: "bg-success-300",
        icon: "fa-chart-line",
        value: this.formatPrice(this.allData['sale']['amount']),
      });

      $vm.summaryBox.push({
        id: "avgSalesPerCustomer",
        label: "Average Sales per Customer",
        background: "bg-primary-300",
        icon: "fa-chart-line",
        value: this.formatPrice($vm.avgSales),
      });

      $vm.summarySpinnerShow = false;
      this.setSummaryData()
    },
    async getSummaryData(key, path, query) {
      let $vm = this;

      let temp = moment()
      let startDate = temp.startOf('month').unix();
      let endDate = temp.endOf('month').unix();

      let url = ''
      if (this.selectedOutlet && this.selectedOutlet.id !== 'all') {
        query += '&outletID=' + this.selectedOutlet.id
      }

      url += `${this.$api.REPORT}/${path}?start=${startDate}&stop=${endDate}&${query}`

      return new Promise((resolve, reject) => {
        $vm
          .$axios({
            method: "get",
            url: url,
            baseURL: $vm.$api.API_ENDPOINT_BEBUSINESS,
            headers: { token: $vm.$session.get("token") },
          })
          .then((response) => {
            this[key] = response.data.total || response.data;
            resolve(this[key])
          })
          .catch((err) => {
            if (err && err.response && err.response.data && err.response.data.error == $vm.$api.INVALID_TOKEN) {
              handleSessionExpired();
              return
            }

            reject()
          });
      })
    },

    async getTableBoxData() {
      this.tableSpinnerShow = true;
      this.tableData = {}
      this.cacheData = {}
      this.barChartData = []

      let task = []
      for (let i = 1; i <= 2; i++) {
        let year = i === 1 ? this.selectedLastYear : this.selectedThisYear

        for (let month = 0; month < 12; month++) {
          // if (this.summaryInclusion === "Exclude Package") {
          //   task.push(this.getTableData('package', year, month, "all", "&skuType=packages"))
          // }
          // task.push(this.getTableData('visit', year, month, "visit/sale"))
          task.push(this.getTableData('all', year, month, "all"))
          task.push(this.getTableData('package', year, month, "sale", "&skuType=packages"))
        }
      }

      let error = await Promise.all(task).catch(e => false)
      if (error === false) {
        this.tableSpinnerShow = false
        return
      }

      this.setTableData()
      this.setTableChart()
      this.tableSpinnerShow = false;
    },
    async getTableData(key, year, month, path, query) {
      query = query || ''

      let $vm = this;

      let temp = moment().set('month', month).set('year', year)
      let startDate = moment(temp).startOf('month').unix()
      let endDate = moment(temp).endOf('month').unix()

      let url = ''
      if (this.selectedOutlet && this.selectedOutlet.id !== 'all') {
        query += '&outletID=' + this.selectedOutlet.id
      }

      url += `${this.$api.REPORT}/${path}?start=${startDate}&stop=${endDate}${query}`

      return new Promise((resolve, reject) => {
        $vm
          .$axios({
            method: "get",
            url: url,
            baseURL: $vm.$api.API_ENDPOINT_BEBUSINESS,
            headers: { token: $vm.$session.get("token") },
          })
          .then((response) => {
            this.cacheData[key] = this.cacheData[key] || {}
            this.cacheData[key][year] = this.cacheData[key][year] || {}
            this.cacheData[key][year][month] = this.cacheData[key][year][month] || {}
            this.cacheData[key][year][month] = response.data

            resolve()
          })
          .catch((err) => {
            if (err && err.response && err.response.data && err.response.data.error == $vm.$api.INVALID_TOKEN) {
              handleSessionExpired();
              return
            }
            
            reject()
          });
      })
    },
    setTableData() {
      let index

      for (let i = 1; i <= 2; i++) {
        let year = i === 1 ? this.selectedLastYear : this.selectedThisYear

        for (let month = 0; month < 12; month++) {
          let first = this.cacheData['all'][year][month]['member']['firstTimeSale'] || 0
          let member = this.cacheData['all'][year][month]['visit']['sales'] || 0
          // let member = this.cacheData['visit'][year][month]['total'] || 0
          let sale = this.cacheData['all'][year][month]['sale']['amount'] || 0

          if (this.summaryInclusion === "Exclude Package") {
            // first -= this.cacheData['package'][year][month]['first'] || 0

            // member -= this.cacheData['customerPackage'][year][month]['total'] || 0
            // member += this.cacheData['customerRedeem'][year][month]['total'] || 0

            sale -= this.cacheData['package'][year][month]['sales']['amount'] || 0
            sale += this.cacheData['all'][year][month]['redeem']['amount'] || 0
          }

          index = 0
          this.tableData[index] = this.tableData[index] || {}
          this.tableData[index][year] = this.tableData[index][year] || []
          this.tableData[index][year][month] = `${first}/${member}`

          index = 1
          this.tableData[index] = this.tableData[index] || {}
          this.tableData[index][year] = this.tableData[index][year] || []
          this.tableData[index][year][month] = sale

          index = 2
          this.tableData[index] = this.tableData[index] || {}
          this.tableData[index][year] = this.tableData[index][year] || []
          if (sale != 0 && member != 0) {
            this.tableData[index][year][month] = sale / member
          } else {
            this.tableData[index][year][month] = 0
          }

          index = 3
          this.tableData[index] = this.tableData[index] || {}
          this.tableData[index][year] = this.tableData[index][year] || []
          this.tableData[index][year][month] = this.cacheData['all'][year][month]['book']['member'] || 0

          index = 4
          this.tableData[index] = this.tableData[index] || {}
          this.tableData[index][year] = this.tableData[index][year] || []
          this.tableData[index][year][month] = this.cacheData['package'][year][month]['sales']['count'] || 0
        }
      }
    },
    setTableChart() {
      if(!this.tableData[this.tableTab] || !this.tableData[this.tableTab]) {
        return
      }

      if(this.tableTab !== 0) {
        this.barChartData = [
          {
            backgroundColor: "#7aece0",
            borderColor: "#1dc9b7",
            borderWidth: 1,
            data: this.tableData[this.tableTab][this.selectedLastYear],
            label: this.selectedLastYear,
          },
          {
            backgroundColor: "#ccbfdf",
            borderColor: "#886ab5",
            borderWidth: 1,
            data: this.tableData[this.tableTab][this.selectedThisYear],
            label: this.selectedThisYear,
          }
        ]

        return
      }

      let temp1 = this.tableData[this.tableTab][this.selectedLastYear]
      let temp2 = this.tableData[this.tableTab][this.selectedThisYear]
      let list1 = []
      let list2 = []
      let list3 = []
      let list4 = []
      for(let temp of temp1) {
        temp = temp.split('/')
        list1.push(temp[0])
        list2.push(temp[1])
      }
      for(let temp of temp2) {
        temp = temp.split('/')
        list3.push(temp[0])
        list4.push(temp[1])
      }

      this.barChartData = [
          {
            backgroundColor: "#7aece0",
            borderColor: "#909090",
            borderWidth: 1,
            data: list1,
            label: `${this.selectedLastYear} - New`,
          },
          {
            backgroundColor: "#9acffa",
            borderColor: "#909090",
            borderWidth: 1,
            data: list2,
            label: `${this.selectedLastYear} - Total`,
          },
          {
            backgroundColor: "#ccbfdf",
            borderColor: "#886ab5",
            borderWidth: 1,
            data: list3,
            label: `${this.selectedThisYear} - New`,
          },
          {
            backgroundColor: "#ffebc1",
            borderColor: "#886ab5",
            borderWidth: 1,
            data: list4,
            label: `${this.selectedThisYear} - Total`,
          },
        ]
    },


    async setSummaryData() {
      var summaryBox = cst.dashboardSalesSummaryBox;
      this.isSpinnerShow = true;

      let temp = moment().set('year', this.selectedThisYear)
      // this.dataThisYear = await this.getSalesItems(temp.startOf('year').unix(), temp.endOf('year').unix());
      this.dataThisYear = await this.getSalesItems('1/1/' + this.selectedThisYear, '31/12/' + this.selectedThisYear);
      // temp = moment().set('year', this.selectedLastYear)
      // this.dataLastYear = await this.getSalesItems(temp.startOf('year').unix(), temp.endOf('year').unix());

      // var tySummary = calculateSalesReportTotal(this.dataThisYear);
      // var thisYearObj = setAYearArr(this.selectedThisYear);

      // var index = 0;
      // for (var m in thisYearObj) {
      //   for (var l = 0; l < this.dataThisYear.length; l++) {
      //     var createDate = new Date(this.dataThisYear[l].createDate * 1000);
      //     if (createDate.getMonth() == index) {
      //       thisYearObj[m].push(this.dataThisYear[l]);
      //     }
      //   }
      //   index++;
      // }

      // const counter = _.filter(thisYearObj, (obj) => Object.values(obj).length != 0).length;
      // this.dashboardSalesSummaryBox = summaryBox.slice();
      // this.dashboardSalesSummaryBox[0].value = formatPrice(tySummary.totalSales);
      // this.dashboardSalesSummaryBox[2].value = counter == 0 ? "-" : formatPrice(tySummary.totalSales / counter);

      // if (this.selectedThisYear != this.selectedLastYear) {
      //   var lySummary = calculateSalesReportTotal(this.dataLastYear);

      //   var lastYearObj = setAYearArr(this.lastYear);
      //   var idx = 0;
      //   for (var n in lastYearObj) {
      //     for (var j = 0; j < this.dataLastYear.length; j++) {
      //       var cDate = new Date(this.dataLastYear[j].createDate * 1000);
      //       if (cDate.getMonth() == idx) {
      //         lastYearObj[n].push(this.dataLastYear[j]);
      //       }
      //     }
      //     idx++;
      //   }
      //   this.dashboardSalesSummaryBox[1].value = formatPrice(
      //     lySummary.totalSales
      //   );

      //   // this.barChartData = this.setBarChartData(thisYearObj, lastYearObj);
      // } else {
      //   this.dashboardSalesSummaryBox = this.dashboardSalesSummaryBox.filter(
      //     function (el) {
      //       return el.id != "lastYearSales";
      //     }
      //   );
      //   // this.barChartData = this.setBarChartData(thisYearObj, {});
      // }

      this.fPieChartData = this.dataThisYear.slice();
      this.pieChartData = this.setPieChartData(this.dataThisYear);
      this.dougnutChartData = this.setDoughnutChartData(this.dataThisYear);
      this.topSpendingMembers = this.setTopItemsMember(this.dataThisYear);
      this.topSalesData = this.setTopItems(this.dataThisYear);

      this.isSpinnerShow = false;
    },
    async getSalesItems(start, end) {
      let $vm = this;
      var outletFilter = this.selectedOutlet.id == "all" ? "" : "&outletID=" + this.selectedOutlet.id;
      let QUERY_STRING =
        "?startDate=" +
        start +
        "&endDate=" +
        end +
        outletFilter;

      const url = this.$api.REPORT_COMPLETED + QUERY_STRING;
      var result = [];
      await this.$axios({
        method: "get",
        url: url,
        baseURL: this.$axios.defaults.baseURL,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data.result;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      return result;
    },

    sortTable(a, b, key) {
      if (key == "noItem") {
        return a.count - b.count;
      } else if (key == "amount") {
        return a.subTotal - b.subTotal;
      }
      return false;
    },
    sortTableMemberItem(a, b, key) {
      if (key == "title") {
        return a.item.title.localeCompare(b.item.title);
      }
      return false;
    },
    filterByType(item) {
      this.selectedType = item;
      var newData = [];
      if (item.id != "all") {
        for (var i = 0; i < this.fPieChartData.length; i++) {
          if (this.fPieChartData[i].item.type == item.id) {
            newData.push(this.fPieChartData[i]);
          }
        }
        this.pieChartData = this.setPieChartData(newData);
      } else {
        this.pieChartData = this.setPieChartData(this.fPieChartData);
      }
    },

    getTotalData(id) {
      var box = this.dashboardSalesSummaryBox.filter(function (el) {
        return el.id == id;
      });
      return box[0].value;
    },
    getCategoryText(type, id) {
      var categoryList = JSON.parse(this.$store.state.category);
      var category = categoryList[type];

      var text = "";
      for (var i = 0; i < category.length; i++) {
        if (i == id) {
          text =
            this.$i18n.t("label.category") + " " + (i + 1) + "- " + category[i];
          break;
        }
      }
      return text;
    },
    getBoxText(id) {
      var text =
        (id == "thisYearSales" ? this.thisYear : this.lastYear) +
        this.$i18n.t("label.annual_sales");
      return text;
    },
    setBarChartData(thisYearObj, lastYearObj) {
      var barChartData = [];
      if (Object.keys(lastYearObj).length != 0) {
        var lastYear = Object.assign({}, lastYearObj);
        var arrLastYear = [];

        for (var n in lastYear) {
          var lySummary = calculateSalesReportTotal(lastYear[n]);
          arrLastYear.push(parseFloat(lySummary.totalSales).toFixed(2));
        }

        barChartData.push({
          label: this.lastYear,
          borderWidth: 1,
          borderColor: "#1dc9b7",
          backgroundColor: "#7aece0",
          data: arrLastYear,
        });
      }

      var thisYear = Object.assign({}, thisYearObj);
      var arrThisYear = [];

      for (var m in thisYear) {
        var tySummary = calculateSalesReportTotal(thisYear[m]);
        arrThisYear.push(parseFloat(tySummary.totalSales).toFixed(2));
      }

      barChartData.push({
        label: this.thisYear,
        borderWidth: 1,
        borderColor: "#886ab5",
        backgroundColor: "#ccbfdf",
        data: arrThisYear,
      });
      return barChartData;
    },
    setPieChartData(thisYearObj) {
      var thisYear = _.groupBy(thisYearObj.slice(), "item.category");

      var data = [];
      for (var m in thisYear) {
        var tySummary = calculateSalesReportTotal(thisYear[m]);
        data.push(parseFloat(tySummary.totalSales).toFixed(2));
      }
      return data;
    },
    setDoughnutChartData(thisYearObj) {
      var thisYear = _.groupBy(thisYearObj.slice(), "item.type");

      var data = [];
      var label = [];
      for (var m in thisYear) {
        if (m != "discount") {
          var tySummary = calculateSalesReportTotal(thisYear[m]);
          data.push(parseFloat(tySummary.totalSales).toFixed(2));
          label.push(m);
          // label.push(m.charAt(0).toUpperCase() + m.slice(1))
        }
      }
      var obj = {
        data: data,
        label: label,
      };
      return obj;
    },
    setTopItems(thisYearObj) {
      var thisYear = _.groupBy(thisYearObj.slice(), "item.itemID");

      var data = [];
      for (var m in thisYear) {
        var tySummary = calculateSalesReportTotal(thisYear[m]);
        data.push({
          itemID: m,
          title: thisYear[m][0].item.title,
          type: thisYear[m][0].item.type,
          category: thisYear[m][0].item.category,
          quantity: thisYear[m].length,
          subTotal: tySummary.totalSales,
        });
      }
      data.sort((a, b) => b.subTotal - a.subTotal);
      data = data.length > 30 ? data.slice(0, 30) : data;
      return data;
    },
    setTopItemsMember(thisYearObj) {
      var thisYear = _.groupBy(thisYearObj.slice(), "member.memberID");
      var data = [];
      for (var m in thisYear) {
        var tySummary = calculateSalesReportTotal(thisYear[m]);
        data.push({
          memberID: m,
          item: thisYear[m],
          count: _.filter(
            thisYear[m],
            (obj) => obj.redeem == "" && obj.item.type != "discount"
          ).length,
          name: thisYear[m][0].member.displayName,
          mobile: thisYear[m][0].member.mobile,
          subTotal: tySummary.totalSales,
        });
      }
      data.sort((a, b) => b.subTotal - a.subTotal);
      data = data.length > 30 ? data.slice(0, 30) : data;
      return data;
    },
    showMemberItems(item, total) {
      var data = [];
      for (var i = 0; i < item.length; i++) {
        if (item[i].redeem == "") {
          if (item[i].item.type != "discount") {
            item[i].quantity = 1;
            item[i].subTotal = getSubTotal(
              item[i].price,
              item[i].discount,
              item[i].outstandings,
              item[i].tax.taxType,
              item[i].tax.tax
            );
            data.push(item[i]);
          }
        }
      }
      data.sort((a, b) => b.subTotal - a.subTotal);
      this.topSpendingMemberItems = data;
      this.memberItemTotal = parseFloat(total).toFixed(2);

      this.toggleModal = true;
      this.sTitle = item[0].member.displayName;
    },
    setItemTypes() {
      this.type = [];
      var itemType =
        this.$i18n.messages[this.$i18n.locale].salon_report.item_types;
      this.type.push({
        id: "all",
        text: this.$i18n.t("label.all", {
          item: this.$i18n.t("label.item_type"),
        }),
      });
      for (var i in itemType) {
        if (i != "discount" && i != "outstandings") {
          this.type.push({
            id: i,
            text: itemType[i],
          });
        }
      }
    },
  },
  async mounted() {
    this.tableTitles = [
      'New/Total',
      'Total Sales',
      'Average Sales',
      'Total Appointment',
      'Total Sign Packages',
    ]

    this.tableHeaders.push("");
    this.tableHeaders.push(...this.$i18n.messages[this.$i18n.locale].calendar);
    this.tableHeaders.push(this.$i18n.t("table.header.total", { item: "" }));

    this.setItemTypes();
    this.selectedType = {
      id: "all",
      text: this.$i18n.t("label.all", { item: this.$i18n.t("label.item_type") }),
    };

    // this.filterData(this.selectedThisYear, this.selectedLastYear, this.selectedOutlet)
  },
};
</script>
<style>
ul.dropdown-menu {
  display: none !important;
}

ul.dropdown-menu.show {
  display: block !important;
}
</style>
<style scoped>
.loading-panel-tag {
  border-color: #909090 !important;
  background-color: #f1f1f1 !important;
}

.small-spinner {
  width: 0.25em;
  height: 0.25em;
  vertical-align: middle;
  margin-right: 0.25em;
}

.show {
  display: block;
}

.border-top-bottom-2 {
  border-top-width: 2px !important;
  border-bottom-width: 2px !important;
}

.modal-body {
  max-height: 80vh;
  min-height: 80vh;
  overflow-y: auto;
}
</style>